import React, { useState, useEffect } from 'react';
import { Calendar, Clock, Hourglass } from 'lucide-react';
import './CountdownTimer.css';

const CountdownTimer = () => {
  const targetDate = new Date('August 1, 2025 12:00:00').getTime();
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  
  function calculateTimeRemaining() {
    const now = new Date().getTime();
    const distance = targetDate - now;
    
    if (distance < 0) {
      return { months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const totalDays = Math.floor(distance / (1000 * 60 * 60 * 24));
    const months = Math.floor(totalDays / 30);
    const days = totalDays % 30;
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    return { months, days, hours };
  }
  
  function getMonthWord(months) {
    if (months % 100 >= 11 && months % 100 <= 19) return 'месяцев';
    switch(months % 10) {
      case 1: return 'месяц';
      case 2: case 3: case 4: return 'месяца';
      default: return 'месяцев';
    }
  }
  
  function getDayWord(days) {
    if (days % 100 >= 11 && days % 100 <= 19) return 'дней';
    switch(days % 10) {
      case 1: return 'день';
      case 2: case 3: case 4: return 'дня';
      default: return 'дней';
    }
  }

  function getHourWord(hours) {
    if (hours % 100 >= 11 && hours % 100 <= 19) return 'часов';
    switch(hours % 10) {
      case 1: return 'час';
      case 2: case 3: case 4: return 'часа';
      default: return 'часов';
    }
  }

  return (
    <div className="countdown-fullwidth">
      <div className="countdown-header">
        <Hourglass className="header-icon" />
        <h2>До III потока осталось</h2>
      </div>
      
      <div className="countdown-grid">
        {timeRemaining.months > 0 && (
          <div className="countdown-card">
            <div className="card-value">{timeRemaining.months}</div>
            <div className="card-label">
              <Calendar className="card-icon" />
              <span>{getMonthWord(timeRemaining.months)}</span>
            </div>
          </div>
        )}
        
        <div className="countdown-card">
          <div className="card-value">{timeRemaining.days}</div>
          <div className="card-label">
            <Calendar className="card-icon" />
            <span>{getDayWord(timeRemaining.days)}</span>
          </div>
        </div>
        
        <div className="countdown-card">
          <div className="card-value">{timeRemaining.hours}</div>
          <div className="card-label">
            <Clock className="card-icon" />
            <span>{getHourWord(timeRemaining.hours)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;